export default "__VITE_ASSET__iYJ$JNwR__"